// EffectPlayer: the client's legacy_vfx effect system, ported from libg 160402020 (visual only).
//
//   const fx = new EffectPlayer(art);
//   const h = fx.play('Fireball_explosion', x, y, { team: 0, angle: 90 });   // logic units, degrees
//   fx.update(dtMs);                                   // integer-ms steps like the client
//   fx.draw(r, 'Ground'); for (const it of fx.collect('Object')) ... (it.sortY, it.draw(r))
//
// Effect instance (vtable 0x188c2a0; ctor 0x82b7ac, update 0x82bf10, stop 0x82d074, isDone 0x82cf98,
// setLoop 0x82cc5c, parent removed 0x82d300): an age in integer ms; each RenderableComponent is created
// on the first update with age >= its Time (0x82c58c) and then updated with the frame's dt; age += dt
// after the components. A Loop effect never finishes until stopped; with ForcedLength it restarts
// (components destroyed) every ForcedLength ms, and a non-looping one finishes at ForcedLength;
// otherwise it is done when every component has started and finished. Stopping (or the followed
// parent disappearing, for a looping effect) stops every component. FollowParent / attached effects
// take the parent sprite's position each update with y ± 0.01 world (in front of the parent). The
// enemy's effects use EnemyVersion (0x82dcb0 → 0xe22124) and their emitters' EnemyVersion (0xe56cbc).
//
// SWF component (0x82a360, update 0x82a994): the clip lasts D = frames · frame time, or the length the
// effect instance carries (+0x98, set by 0x82ccd8; −1 = the clip's), plus a hold time E (+0x9c, set by
// 0x82ccd0; 0 by default; both read when the component is made, so only the effect's own SWF
// components get them, not those of nested effects); while not looping it is done once t >= D + E;
// frame ⌊t·frames / D⌋ (looping: t mod D); once t >= D (clips of 2+ frames) it holds the last frame
// with alpha (D + E − t) / E (0x123cbc0: clamped to 0..1, stored as a byte); scale RenderableScale% ×
// effect Scale; placed at the effect position (setPos3D 0x851b84).
//
// Particle emitter (SpecialEffect None; ctor 0x830b90, update 0x8319e8, spawn 0x831b90, new particle
// 0x8311e8): life = MinLife' + rand(MaxLife − MinLife') with MinLife' = max(MinLife, 1) (setLoop:
// looping → 0 = forever; else 0 → 2000; stop → 1). Each update steps the live particles (removing the
// dead ones), then spawns while life = 0 or age < life, then age += dt. Spawning: with the next-spawn
// timer >= 1 it counts down by dt; otherwise, while fewer than ParticleCount (≤ 100) are alive, spawn
// one pre-aged by −timer and add MinInterval + rand(MaxInterval − MinInterval) to the timer. A new
// particle picks a random resource; its angle is base + MinAngle + rand(range) (ParticleRandomAngle)
// or base + MinAngle + (⌊i·range / ParticleCount⌋ mod range) for the i-th spawn, + the parent's angle
// (ParticleAngleRelativeToParent); speed MinSpeed + rand(Δ)·effect Scale; vz (MinVZ + rand(Δ))·0.1;
// radius (MinR + rand(Δ)) / 2 along the angle; ParticleStartX/Z · 0.1; ParticleStartXYAreaRadius
// adds (sin a · 15, −cos a · 12) · (rand() mod R) · 0.002. Positions are world units (logic · 0.002).
//
// Particle (container, vtable 0x188c578; ctor 0x82f2c0, update 0x83094c → step 0x82fcc4, integrate
// 0x8306a4, bounce 0x831d08): Inertia ≠ 0 steps in fixed 16 ms slices. Integration from the launch:
// speed −= Inertia · dt / 1000 (clamped at 0); x += speed · cos · dt · 1e−4, y += speed · sin · dt · 1e−4;
// z = z0 + (vz + g · t/2) · t / 1000 with g = Gravity · 1e−4 and t the time since launch; hitting z = 0
// (unless NoBounce) restarts the arc at 0 with direction and vz × 0.65 (StopOnBounce: everything 0 and
// the clip stops). Scale RandomScale-jittered × RenderableScale% × lerp(StartScale, EndScale)/100 over
// life (only when either is set); FadeIn/FadeOut alpha; RotateToDirection turns the clip by the launch
// angle (not with FrameFromAngle, which launches along (sin, −cos) and picks frame ⌊⌊angle⌋·n / 360⌋);
// RotateMin/MaxSpeed spin per step. Clips play once over the particle's life (frame
// ⌊age·n/life⌋) unless LoopParticleClip (loop) or PlayParticleClipOnce / a "playOnce" first label
// (play once at fps). Tails (Min/MaxTailLength ms): a second point integrated `tail` ms behind; the
// clip is stretched from it to the head ((|d| + h)·s / h along atan2 d, h = the clip's height
// 0x123ca58: its current frame's bounds through its own rotation, before this step's frame update;
// the client measures the height, not the width). Shadow emitters add a copy in
// the Ground layer at (x, y, 0) offset (−5, 15 + ShadowYShift) px, skew 0.6, flipped vertically,
// tinted by the location shadow colour × ShadowMul% and alpha ShadowA · ShadowMulA / 25500.
//
// Layers (0xe22490 / 0x8569f0, drawn in this order): Base, Shadow (the shadow silhouette), Ground,
// GroundAbility, Object, Above. Base, Ground and Object are sorted every frame by the key vt+0x168
// (0x856a88): the ground-projected y of each sprite (+ SortingOffset for particles); GroundAbility and
// Above keep creation order. A missing Layer means Ground (0xe65a8c).
//
// Component offset (vt+0x48: effect 0x82d204 → SWF 0x82a8e0 / emitter 0x831978): set from the instance's
// +0xa8/+0xac when a component is made (0x82c58c) and by the caller (PlayOptions.offset); a SWF component
// moves its inner clip by it (0x123c548, inside the component's scale) and a beam starts there (sc/beam.ts);
// an emitter gives it to every particle (0x830940 → +0x1c4/+0x1c8), added to the particle's display
// position in battle px (0x8306a4, 2D path). Each update (0x82bf10 @0x82c2ac) an effect whose parent is a
// character (actor class 5) with PivotClip (data +0xb8) or ParentLookAtOffsetRadius (data +0xb0 → effect
// +0x1c, 0xe21f54) re-sets every component's offset: the parent sprite's direct child named PivotClip
// (vt+0x150 → 0x1241adc, case-insensitive) gives its matrix (tx, ty); without one the radius r gives
// (⌊r·sin a / 1024⌋·0.03, −⌊r·sin(a + 90) / 1024⌋·0.024) on the view's direction angle a (+0x4dc, the
// picked direction's index · 180 / (N − 1), 0x84a7f8); x × the mirror sign (+0x4e8), y + TargetEffectY
// (0xde1220), both truncated to int; with neither nothing changes (parentOffset below). The 3D-model path
// (view +0x268) does not exist in this build's 2D views.
//
// Text (0x82c58c): when the instance carries a text (+0x28/+0x2c, set only by 0x82d3cc: view vt+0x100
// 0x84f444 "+%d" on GetMana, and 0xfb2c78 "%i"), each own SWF component sets it on the child
// TextInstanceName of the root clip's child TextParentInstanceName (0x1242e78 → 0x12432e0, direct children,
// case-insensitive; here by instance name at any depth, A). Without a text the TextField keeps its authored
// text (effect_charge's `txt` is empty).
//
// Trails: none. TrailMaxPoints / TrailDuration / TrailSWF / TrailExportName are only named by the emitter
// schema 0xe572b4 (0xe578e0..0xe57964); no emitter getter (0xe56ccc..0xe57208, by name through 0xe0c420 /
// 0xe0c4a0 / 0xe0ca24) and no data table reads them, so the particle code (0x82f2c0..0x831d08) draws no
// trail (Magic Archer's projectile_speed_line particles are plain RotateToDirection particles).
//
// Approximations (A): the client's Mersenne-Twister effect RNG is replaced by a seeded xorshift;
// emitter modifiers (EmitterReplaceType), SpecialEffect emitter types 1/2, ParticleRadiusAspect,
// ResourceFromAngle, AngularSpeed spirals around a parent, the offset of particle shadow copies and the
// 3D/light paths are not ported.

import type { Col, Mat } from './math.ts';
import type { ScLibrary } from './library.ts';
import type { ClipRef, EffectComponent, EffectDef, EmitterDef } from './manifest.ts';
import type { ScRenderer } from './renderer.ts';
import type { BattleArt } from './battle_art.ts';
import { ClipPlayer } from './anim.ts';
import { beamMatrix } from './beam.ts';
import { filterClipLength, filterFrame } from './area_view.ts';
import { fxSoundStop, fxSoundUpdate } from './sound.ts';
import { sin1024 } from '../../../core/src/trig.ts';
import { McNode } from './movieclip.ts';

/** logic units → world units */
const W = 0.002;

export interface PlayOptions {
  z?: number; // logic units above ground
  team?: 0 | 1; // 1 = the enemy of the viewing player: EnemyVersion effects/emitters
  /** effect angle in degrees (world space, the client's 0..360), e.g. the hit direction */
  angle?: number;
  scale?: number; // extra multiplier (effect scale)
  /** attach to a moving parent: its drawn position [x, y, z] in logic units, or null once it is gone */
  follow?: () => [number, number, number] | null;
  /** the parent's angle in degrees (ParticleAngleRelativeToParent), e.g. a projectile's flight */
  parentAngle?: () => number;
  /** setLoop right after creation: 0x82dedc plays looping (true), 0x82dc54 once (false); unset = the
   * effect's own Loop (0x82dcb0) */
  loop?: boolean;
  /** SWF length D for the effect's own SWF components (effect +0x98, 0x82ccd8; −1 = each clip's length) */
  swfLength?: number;
  /** hold-and-fade time E after D for the effect's own SWF components (effect +0x9c, 0x82ccd0) */
  swfFade?: number;
  /** skip emitters whose particles are permanent (ParticleMinLife >= 100 s), e.g. tower rubble */
  skipPersistent?: boolean;
  /** draw nothing (HideWhenDelayed parents) while this returns true */
  hidden?: () => boolean;
  /**
   * Beam target (0x82d484 → each SWF component's +0x190, sc/beam.ts): the target actor's logic
   * [x, y, z + 2·CollisionRadius] each frame; null once it is gone (a looping beam then hides, another keeps
   * its last matrix: 0x82b40c / 0x82a994).
   */
  target?: () => [number, number, number] | null;
  /** the target view's damage pivot in battle-layer px (0x84eb7c(view, −1, 1)), added to the beam end */
  targetPivot?: () => [number, number] | null;
  /** fixed beam end (0x82d508 → SWF +0x158..+0x164): logic [x, y, z] */
  targetPoint?: [number, number, number];
  /** source offset in battle-layer px (effect vt+0x48 0x82d204 → each component's vt+0x48) */
  offset?: [number, number];
  /**
   * The parent actor of Filter components (0x82c58c type 1 → 0x82ea34 with the effect's parent +0x48):
   * the filter recolours that actor's sprites while it runs (0x82ebdc); see EffectPlayer.filters.
   */
  filterParent?: number;
  /**
   * The effect's speed (+0xb0, 0x82ccf0; 1 by default): its sound components start with this pitch when it
   * is not 1 (0x82bf10 → 0xcbc74c). View vt+0xc0 0x84f11c sets it from its float argument (the
   * AttackStartEffect's buff pitch 0xfc24e0, sc/char_effects.ts attackStartPitch; 1.0 elsewhere).
   */
  soundPitch?: number;
  /** The instance's text (+0x28, 0x82d3cc), set on its SWF components' TextInstanceName child (0x82c58c). */
  text?: string;
  /**
   * The parent character's view (effect +0x48 of actor class 5) for PivotClip / ParentLookAtOffsetRadius
   * (0x82bf10 @0x82c2ac): read every update; null while there is none.
   */
  parentView?: () => ParentView | null;
}

/** What 0x82bf10 reads of the parent character's view for the component offset. */
export interface ParentView {
  /** view +0x4dc (0x84ab00): the shown direction's angle, direction index · 180 / (N − 1) (0x84a7f8) */
  dirAngle: number;
  /** view +0x4e8 (0x84ab08): the sprite's mirror sign, ±1 */
  mirror: number;
  /** CharacterData TargetEffectY (+0x808, 0xde1220) */
  targetEffectY: number;
  /** the current sprite frame's direct child named `name` (0x1241adc, case-insensitive): its matrix tx, ty */
  child(name: string): [number, number] | null;
}

/**
 * 0x82bf10 @0x82c2ac: the offset every component of an effect with a character parent gets this update,
 * or null when it keeps its offset (no PivotClip child and r = 0, or neither field set).
 * `radius` = ParentLookAtOffsetRadius (effect +0x1c).
 */
export function parentOffset(pivotClip: string | undefined, radius: number, v: ParentView): [number, number] | null {
  if (!radius && !pivotClip) return null;
  const c = pivotClip ? v.child(pivotClip) : null;
  let x: number, y: number;
  if (c) {
    x = c[0]; y = c[1];
  } else {
    if (!radius) return null;
    const sx = Math.trunc((sin1024(v.dirAngle) * radius) / 1024);
    const sy = Math.trunc((sin1024(v.dirAngle + 90) * radius) / 1024);
    x = Math.fround(sx * Math.fround(0.030000001));
    y = Math.fround(-sy * Math.fround(0.024));
  }
  const fx = Math.fround(v.mirror * x);
  const fy = Math.fround(y + v.targetEffectY);
  // (int) conversions (fcvtzs)
  return [Math.trunc(fx) | 0, Math.trunc(fy) | 0];
}

export interface DrawItem {
  layer: string;
  sortY: number; // sort key: ground-projected SC px y (+ SortingOffset)
  draw(r: ScRenderer): void;
}

/** Visual-only random numbers: rand(n) in [0, n), 0 for n <= 0 (stands in for 0x12949ec). */
class Rng {
  private s: number;
  constructor(seed: number) { this.s = seed >>> 0 || 1; }
  u32(): number {
    let s = this.s;
    s ^= s << 13; s >>>= 0;
    s ^= s >>> 17;
    s ^= s << 5; s >>>= 0;
    this.s = s;
    return s;
  }
  int(n: number): number {
    n = Math.trunc(n);
    return n > 0 ? this.u32() % n : 0;
  }
  /** C rand(): 0..2^31−1 */
  crand(): number { return this.u32() >>> 1; }
}

interface Ctx {
  art: BattleArt;
  rng: Rng;
  seq: () => number;
  /** draw particle shadow copies */
  shadows: boolean;
  shadowCol: Col;
  shadowA: number;
  /** effect constructor 0x82b7ac: ShakeScreen / ShakeMaxIntensity (ms) start a screen shake (0x856a70) */
  shake: (def: { ShakeScreen?: number; ShakeMaxIntensity?: number }) => void;
}

// ---------------------------------------------------------------------------------- particles

interface Motion {
  tAge: number; // ms since launch (int)
  x: number; y: number; z0: number; z: number;
  dirX: number; dirY: number; vz: number; speed: number;
}

class Particle {
  readonly lib: ScLibrary;
  readonly exp: string;
  readonly frames: number;
  readonly seq: number;
  /** 'life': frame by age over life; 'clip': the clip plays on its own (loop or once) */
  mode: 'life' | 'clip';
  player: ClipPlayer | null = null;
  frame = 0;
  m: Motion;
  t: Motion | null = null; // tail point
  tail: number;
  age = 0;
  life = 0;
  acc = 0; // fixed-step accumulator (Inertia)
  rs = 1; // random scale factor (+0x1e4)
  compScale = 1; // RenderableScale (+0x1bc)
  clipRot: number; // the clip's own rotation (RotateToDirection without FrameFromAngle), degrees
  dirAngle: number; // +0x1d8: the launch angle with RotateToDirection, else 0
  rotSpeed: number;
  rotAcc = 0;
  /** container matrix a, b, c, d and screen position */
  a = 1; b = 0; c = 0; d = 1;
  px = 0; py = 0; gy = 0;
  alpha = 1;
  readonly floor: number;
  readonly g: number;
  readonly sortOff: number;
  readonly em: Emitter;

  constructor(em: Emitter, ref: ClipRef, lib: ScLibrary, x: number, y: number, z: number, vz: number, g: number,
    radius: number, angle: number, speed: number, tail: number, bounces: boolean, sortOff: number, seq: number) {
    this.em = em;
    const e = em.e;
    this.lib = lib;
    this.exp = ref.export;
    this.frames = Math.max(1, ref.frames ?? lib.frameCount(ref.export) ?? 1);
    this.seq = seq;
    const rad = angle * 0.017453294;
    let cx = Math.cos(rad), sy = Math.sin(rad);
    if (e.FrameFromAngle) { const c = cx; cx = sy; sy = -c; }
    x += radius * cx;
    y += radius * sy;
    if (e.InverseSpeed) { cx = -cx; sy = -sy; }
    this.m = { tAge: 0, x, y, z0: z, z, dirX: cx, dirY: sy, vz, speed };
    this.tail = tail;
    if (tail) this.t = { tAge: -tail, x, y, z0: z, z, dirX: cx, dirY: sy, vz, speed };
    this.g = g;
    this.floor = bounces ? 0 : -1e6;
    this.sortOff = sortOff;
    this.dirAngle = e.RotateToDirection ? angle : 0;
    this.clipRot = e.RotateToDirection && !e.FrameFromAngle ? angle : 0;
    // the clip plays on its own when its first label is "playOnce", PlayParticleClipOnce or LoopParticleClip
    const once = ref.labels?.['0'] === 'playOnce' || !!e.PlayParticleClipOnce;
    if (once || e.LoopParticleClip) {
      this.mode = 'clip';
      this.player = new ClipPlayer(this.frames, ref.fps || 30);
      if (once) this.player.playRange(0, this.frames - 1, false);
    } else {
      this.mode = 'life';
    }
    const rnd = (e.RandomScale as number | undefined) ?? 0;
    if (rnd > 0) this.rs += (em.ctx.rng.int(rnd * 2) - rnd) * 0.01;
    const rmin = (e.RotateMinSpeed as number | undefined) ?? 0, rmax = (e.RotateMaxSpeed as number | undefined) ?? 0;
    this.rotSpeed = ((((rmax - rmin) * em.ctx.rng.int(100)) / 100 | 0) + rmin) * 0.01;
    const amin = (e.ParticleMinSpawnAngle as number | undefined) ?? 0, amax = (e.ParticleMaxSpawnAngle as number | undefined) ?? 0;
    if (amin !== amax) this.setRot(amin + em.ctx.rng.int(amax - amin), this.rs);
    this.place(this.m);
  }

  private setRot(deg: number, s: number): void {
    const r = deg * 0.017453292;
    const c = Math.cos(r), sn = Math.sin(r);
    this.a = c * s; this.b = sn * s; this.c = -sn * s; this.d = c * s;
  }

  /** setPos3D: world position (relative to the emitter with ParticlesFollowParent) → screen + sort key */
  private place(m: Motion): void {
    const em = this.em;
    let x = m.x, y = m.y;
    if (em.followParticles) { x += em.x; y += em.y; }
    const art = em.ctx.art;
    const [px, py] = art.gameToPx(x / W, y / W, m.z / W);
    this.px = px; this.py = py;
    this.gy = art.gameToPx(x / W, y / W, 0)[1];
  }

  /** 0x8306a4 */
  private integrate(dt: number, m: Motion): void {
    const e = this.em.e;
    const oldZ = m.z;
    const t = Math.max(m.tAge, 0);
    m.z = m.z0;
    const ang = (e.AngularSpeed as number | undefined) ?? 0;
    if (ang !== 0) {
      const r = (((((e.ParticleStartXYAreaRadius as number | undefined) ?? 0) * t) | 0) * 0.01) / (this.life || 1);
      const a = (e.InverseSpeed ? -0.0001 : 0.0001) * (t * ang);
      m.dirX = Math.sin(a) * r;
      m.dirY = Math.cos(a) * r;
    }
    const sp = m.speed + ((e.Inertia as number | undefined) ?? 0) * dt * -0.001;
    m.speed = sp;
    if (sp >= 0) {
      m.x += sp * m.dirX * dt * 0.0001;
      m.y += dt * 0.0001 * m.speed * m.dirY;
    } else {
      m.speed = 0;
    }
    let z = m.z + (m.vz + this.g * (t / 2)) * t * 0.001;
    if (z < this.floor) z = this.floor;
    m.z = z;
    this.place(m);
    if (m.z <= this.floor && this.floor < oldZ) {
      m.z0 = this.floor;
      // 0x831d08 (no emitter modifiers): restart the arc
      m.tAge = 0;
      if (!e.StopOnBounce) {
        m.dirX *= 0.65; m.dirY *= 0.65; m.vz *= 0.65;
      } else {
        m.dirX = 0; m.dirY = 0; m.vz = 0;
        if (this.mode === 'life') this.mode = 'clip';
        if (this.player) this.player.gotoAndStop(this.player.frame);
        else { this.player = new ClipPlayer(this.frames, 30); this.player.gotoAndStop(this.frame); }
      }
    }
  }

  /** 0x83094c: true when dead */
  update(dt: number): boolean {
    if (!this.em.e.Inertia) return this.step(dt);
    this.acc += dt;
    if (this.acc < 16) return false;
    let dead = false;
    for (;;) {
      dead = this.step(16);
      if (dead) break;
      const a = this.acc;
      this.acc = a - 16;
      if (a <= 0x1f) break;
    }
    return dead;
  }

  /** 0x82fcc4 */
  private step(dt: number): boolean {
    const e = this.em.e;
    let tx = 0, ty = 0;
    if (this.t) {
      this.t.tAge += dt;
      this.integrate(this.t.tAge < 0 ? 0 : dt, this.t);
      tx = this.px; ty = this.py;
    }
    this.m.tAge += dt;
    this.integrate(dt, this.m);
    let s = this.rs;
    const s0 = (e.StartScale as number | undefined) ?? 0, s1 = (e.EndScale as number | undefined) ?? 0;
    if (s0 || s1) {
      s = this.rs * 0.01 * this.compScale * ((this.age * (s1 - s0)) / (this.life || 1) + s0);
      this.a = s; this.d = s;
    }
    if (this.t) {
      const w = this.height();
      const dx = this.px - tx, dy = this.py - ty;
      if (w > 0) {
        const len = ((Math.sqrt(dx * dx + dy * dy) + w) * s) / w;
        const r = Math.atan2(dy, dx);
        const c = Math.cos(r), sn = Math.sin(r);
        this.a = c * len; this.b = sn * len; this.c = -sn * s; this.d = c * s;
      }
      this.px = tx + dx * 0.5;
      this.py = ty + dy * 0.5;
    }
    if (this.mode === 'life') {
      const n = this.frames;
      let f = this.life ? Math.trunc((this.age * n) / this.life) : 0;
      if (f < 0) f = 0;
      if (f >= n) f = n - 1;
      if (e.FrameFromAngle) {
        // the frame picks the launch direction instead of the age
        const an = Math.trunc(this.dirAngle) * n;
        f = an < -359 ? 0 : Math.min(n - 1, Math.trunc(an / 360));
      }
      this.frame = f;
    }
    if (Math.abs(this.rotSpeed) > 0.05) {
      this.rotAcc += this.rotSpeed;
      this.setRot((e.FrameFromAngle ? 0 : this.dirAngle) + this.rotAcc, s);
    }
    let a = 1;
    const fin = (e.FadeInDuration as number | undefined) ?? 0;
    if (this.age < fin) a = this.age / fin;
    const fout = (e.FadeOutDuration as number | undefined) ?? 0;
    if (fout > 0) {
      const from = this.life - fout, into = this.age - from;
      if (into !== 0 && from <= this.age) a *= 1 - into / fout;
    }
    this.alpha = Math.max(0, Math.min(1, a));
    this.age += dt;
    return this.life <= this.age;
  }

  /**
   * The clip's height (0x123ca58: maxY − minY of its current frame through its own rotation matrix)
   * for tail stretching. The frame is the one shown before this step's frame update.
   */
  private height(): number {
    const r = this.clipRot * 0.017453292;
    const c = Math.cos(r), sn = Math.sin(r);
    return this.lib.frameHeight(this.exp, this.frame, [c, sn, -sn, c]);
  }

  advanceClip(dtS: number): void {
    if (this.player) {
      this.player.advance(dtS);
      this.frame = this.player.frame;
    }
  }

  item(layer: string, alphaMul: number): DrawItem | null {
    const al = this.alpha * alphaMul;
    if (al <= 0.002) return null;
    const lib = this.lib, exp = this.exp, f = this.frame;
    const cr = this.clipRot * 0.017453292;
    const kc = Math.cos(cr), ks = Math.sin(cr);
    // container [a, b, c, d] times the clip's own rotation (RotateToDirection); the emitter's component
    // offset (+0x1c4/+0x1c8, 0x830940) is added to the display position in battle px (0x8306a4)
    const em = this.em;
    const m: Mat = [this.a * kc + this.c * ks, this.b * kc + this.d * ks, this.c * kc - this.a * ks, this.d * kc - this.b * ks,
      this.px + em.ox, this.py + em.oy];
    const col: Col = [1, 1, 1, Math.trunc(al * 255) / 255, 0, 0, 0];
    return { layer, sortY: this.gy + this.sortOff, draw: (r) => r.draw(lib, exp, f, m, col) };
  }

  shadowItem(alphaMul: number): DrawItem | null {
    const e = this.em.e;
    const ctx = this.em.ctx;
    const al = this.alpha * alphaMul * ((ctx.shadowA * ((e.ShadowMulA as number | undefined) ?? 0)) / 25500);
    if (al <= 0.002) return null;
    const art = ctx.art;
    let x = this.m.x, y = this.m.y;
    if (this.em.followParticles) { x += this.em.x; y += this.em.y; }
    const [gx, gy] = art.gameToPx(x / W, y / W, 0);
    const shift = (e.ShadowYShift as number | undefined) ?? 0;
    const flip = !e.IgnoreShadowFlip;
    const m: Mat = [this.a, this.b, flip ? 0.6 : this.c, flip ? -this.d : this.d, gx - 5, gy + shift + 15];
    const mul = (k: string) => Math.min(1, Math.max(0, ((ctx.shadowCol[k === 'R' ? 0 : k === 'G' ? 1 : 2] * 255) *
      ((e[`ShadowMul${k}`] as number | undefined) ?? 0)) / 25500));
    const col: Col = [mul('R'), mul('G'), mul('B'), al, 0, 0, 0];
    const lib = this.lib, exp = this.exp, f = this.frame;
    return { layer: 'Ground', sortY: gy, draw: (r) => r.draw(lib, exp, f, m, col) };
  }
}

// ---------------------------------------------------------------------------------- emitter

class Emitter {
  readonly kind = 'emit';
  readonly e: EmitterDef;
  readonly ctx: Ctx;
  readonly fx: Fx;
  readonly layer: string;
  life: number;
  age = 0;
  next = 0;
  count: number;
  counter = 0;
  parts: Particle[] = [];
  x = 0; y = 0; z = 0; // world units
  readonly followParticles: boolean;
  /** effect Scale (+0x8c), RenderableScale (+0x90), base angle in degrees (+0xd8) */
  readonly scale: number;
  readonly compScale: number;
  readonly baseAngle: number;

  constructor(ctx: Ctx, fx: Fx, e: EmitterDef, layer: string, scale: number, compScale: number, baseAngle: number) {
    this.scale = scale;
    this.compScale = compScale;
    this.baseAngle = baseAngle;
    this.ctx = ctx;
    this.fx = fx;
    this.e = e;
    this.layer = layer;
    const min = Math.max(e.MinLife ?? 0, 1), max = e.MaxLife ?? 0;
    this.life = ctx.rng.int(max - min) + min;
    // ParticleCount; the low-end quarter count is not applied (high-quality client, A), capped at 100
    this.count = Math.min(100, e.ParticleCount ?? 0);
    this.followParticles = !!e.ParticlesFollowParent;
  }

  setLoop(loop: boolean): void {
    if (loop) this.life = 0;
    else if (this.life === 0) this.life = 2000;
  }

  stop(): void { this.life = 1; }

  setPos(x: number, y: number, z: number): void { this.x = x; this.y = y; this.z = z; }

  /** component offset in battle px (vt+0x48 0x831978: +0xc0/+0xc4, given to every particle, 0x830940) */
  ox = 0; oy = 0;
  setOffset(x: number, y: number): void { this.ox = x; this.oy = y; }

  isDone(): boolean { return this.life !== 0 && this.life <= this.age && this.parts.length === 0; }

  /** 0x8319e8: true when finished */
  update(dt: number): boolean {
    const n0 = this.parts.length;
    const emitting = !(this.life !== 0 && this.life <= this.age);
    if (n0 || emitting) {
      for (let i = this.parts.length - 1; i >= 0; i--) {
        if (this.parts[i].update(dt)) this.parts.splice(i, 1);
      }
      if (emitting) this.spawn(dt);
      this.age += dt;
    }
    for (const p of this.parts) p.advanceClip(dt / 1000);
    return n0 === 0 && !emitting;
  }

  /** 0x831b90 */
  private spawn(dt: number): void {
    const e = this.e;
    if (!e.particles.length) return;
    let next = this.next;
    if (next >= 1) { this.next = next - dt; return; }
    if (this.parts.length < this.count) {
      const minI = e.ParticleMinInterval ?? 0, maxI = e.ParticleMaxInterval ?? 0;
      let p = this.newParticle(-next);
      while (p) {
        next = minI + next + this.ctx.rng.int(maxI - minI);
        this.next = next;
        if (this.count <= this.parts.length || next > 0) return;
        p = this.newParticle(-next);
      }
    }
    this.next = 0;
  }

  /** 0x8311e8 */
  private newParticle(preAge: number): Particle | null {
    if (this.parts.length >= this.count) return null;
    const e = this.e, rng = this.ctx.rng;
    const ref = e.particles[rng.int(e.particles.length)];
    const lib = this.ctx.art.libs.get(ref.sc) ?? (this.ctx.art.lib(ref.sc), undefined); // requests a missing one
    const minA = e.ParticleMinAngle ?? 0, rangeA = (e.ParticleMaxAngle ?? 0) - minA;
    let angle: number;
    if (!e.ParticleRandomAngle) {
      const n = rangeA < 2 ? 1 : rangeA; // unsigned compare in the client
      const i = this.counter++;
      const v = this.count ? Math.trunc((i * n) / this.count) : 0;
      angle = this.baseAngle + ((v - Math.trunc(v / n) * n) + minA);
    } else {
      angle = this.baseAngle + (rng.int(rangeA) + minA);
    }
    if (e.ParticleAngleRelativeToParent && this.fx.parentAngle) angle += this.fx.parentAngle();
    const minS = e.ParticleMinSpeed ?? 0;
    const speed = Math.trunc(minS + rng.int((e.ParticleMaxSpeed ?? 0) - minS) * this.scale);
    const minVz = e.ParticleMinVelocityZ ?? 0;
    const vz = (rng.int((e.ParticleMaxVelocityZ ?? 0) - minVz) + minVz) * 0.1;
    const minT = e.ParticleMinTailLength ?? 0;
    const tail = rng.int((e.ParticleMaxTailLength ?? 0) - minT) + minT;
    const minR = e.ParticleMinRadius ?? 0;
    const radius = (rng.int((e.ParticleMaxRadius ?? 0) - minR) + minR) / 2;
    let x = this.followParticles ? 0 : this.x;
    let y = this.followParticles ? 0 : this.y;
    const area = e.ParticleStartXYAreaRadius ?? 0;
    const angSpeed = (e.AngularSpeed as number | undefined) ?? 0;
    if (area && angSpeed < 1) {
      const a = (rng.crand() % 360) * 0.01745328;
      const d = (rng.crand() % area) * 0.002;
      x += Math.sin(a) * 15 * d;
      y -= Math.cos(a) * 12 * d;
    }
    const lifeMin = e.ParticleMinLife ?? 0;
    const life = rng.int((e.ParticleMaxLife ?? 0) - lifeMin) + lifeMin;
    if (!lib) return null;
    const p = new Particle(this, ref, lib, x + (e.ParticleStartX ?? 0) * 0.1, y, this.z + (e.ParticleStartZ ?? 0) * 0.1, vz,
      (e.ParticleGravity ?? 0) * 0.0001, radius, angle, speed, tail, !e.NoBounce,
      (e.SortingOffset as number | undefined) ?? 0, this.ctx.seq());
    // vt+0x30(effect scale) before the scale curve, then RenderableScale (0x8309f8)
    p.a = this.scale; p.d = this.scale;
    p.compScale = this.compScale;
    p.life = life;
    p.update(preAge);
    this.parts.push(p);
    return p;
  }
}

// ---------------------------------------------------------------------------------- SWF component

class SwfComp {
  readonly kind = 'swf';
  readonly lib: ScLibrary;
  readonly c: EffectComponent;
  readonly frames: number;
  /** D (+0x148) and the hold-and-fade time E (+0x14c) */
  readonly dur: number;
  readonly hold: number;
  readonly seq: number;
  loop = false;
  t = 0;
  frame = 0;
  done = false;
  /** the display object's alpha byte / 255, written only by the hold path (0x123cbc0) */
  alpha = 1;
  x = 0; y = 0; z = 0;
  readonly scale: number;
  /**
   * The component's MovieClip (0x82a360 → 0x1210b30, param_1[0x27]): its root is stopped on the component's
   * frame each update (0x1242234) and the render advances it, so its nested clips keep their own playheads
   * (0x123f55c); null while the library loads.
   */
  readonly inst: McNode | null;
  constructor(ctx: Ctx, c: EffectComponent, lib: ScLibrary, scale: number, len = -1, hold = 0) {
    this.scale = scale;
    this.c = c;
    this.lib = lib;
    this.inst = c.export && typeof lib.clip === 'function' ? McNode.of(lib, c.export) : null; // (test stand-ins have no clips)
    this.frames = Math.max(1, c.frames ?? lib.frameCount(c.export!) ?? 1);
    const fps = c.fps || 30;
    // 0x82a360: D = −1 becomes (int)(frame time · (frames · 1000)) in float32
    this.dur = len !== -1 ? len : Math.trunc(Math.fround(Math.fround(1 / fps) * (this.frames * 1000)));
    this.hold = hold;
    this.seq = ctx.seq();
  }
  setLoop(loop: boolean): void { this.loop = loop; }
  stop(): void { this.loop = false; }
  setPos(x: number, y: number, z: number): void { this.x = x; this.y = y; this.z = z; }
  /** offset (+0x168 / +0x16c, vt+0x48 0x82a8e0): the inner clip's position inside the component */
  ox = 0; oy = 0;
  setOffset(x: number, y: number): void { this.ox = x; this.oy = y; }
  isDone(): boolean { return this.done; }
  /** the beam clip's last matrix relative to the component's position (kept once its target is gone) */
  beamLocal: Mat | null = null;
  /** 0x82a994 (no forced frame percent +0x154, no beam targets +0x188 / +0x190) */
  update(dt: number): boolean {
    if (this.done) return true; // finished by its beam losing its target (+0x181)
    const D = this.dur, E = this.hold;
    if (!this.loop) {
      if (E + D <= this.t) { this.done = true; return true; }
    } else if (D) {
      this.t %= D;
    }
    if (this.frames >= 2) {
      let f = D ? Math.trunc((this.t * this.frames) / D) : 0;
      if (D <= this.t) {
        f = this.frames - 1;
        // vt+0x58 setAlpha((D − t + E) / E) (float32; E = 0 gives ±inf / NaN, handled by the clamp)
        this.alpha = alphaByte(Math.fround((D - this.t + E) / E)) / 255;
      }
      this.frame = f;
      this.inst?.gotoAndStop(f);
    }
    // the render's advance of the component's clip (a 1-frame root plays on its own, 0x82a994 skips the goto)
    this.inst?.advance(dt / 1000);
    this.t += dt;
    return false;
  }
}

/** 0x123cbc0: alpha clamped to 0..1 (NaN → 0) and stored as a byte. */
export function alphaByte(v: number): number {
  const a = v <= 1 ? v : 1;
  return Math.trunc(0 <= v ? a * 255 : 0);
}

// ---------------------------------------------------------------------------------- filter component

/**
 * Filter component (0x82c58c type 1 → ctor 0x82ea34, update 0x82ebdc, stop 0x82ebc4): a clip whose
 * first element's colour transform multiplies the parent view's sprite colours (rgb·a ×, rgb +, clamped)
 * each update. It lasts D = the effect instance's +0x98 or, at −1, the clip's frames · frame time; it
 * loops with the effect data's Loop (+0xb), else it is done once t >= D; frame ⌊t·frames / D⌋ clamped
 * to the last. The filter's matrix flag (+0x31, the instance's +8) is never set: colour only. The
 * clip length and frame step are the buff filter's (sc/area_view.ts filterClipLength / filterFrame),
 * one implementation for both users of the class.
 */
class FilterComp {
  readonly kind = 'filter';
  readonly lib: ScLibrary;
  readonly exp: string;
  readonly frames: number;
  readonly dur: number;
  readonly loopData: boolean;
  readonly parent: number;
  t = 0;
  frame = 0;
  done = false;
  constructor(lib: ScLibrary, exp: string, frames: number, fps: number, len: number, loopData: boolean, parent: number) {
    this.lib = lib;
    this.exp = exp;
    this.frames = Math.max(1, frames);
    this.dur = len !== -1 ? len : filterClipLength(this.frames, fps);
    this.loopData = loopData;
    this.parent = parent;
  }
  setLoop(_loop: boolean): void { /* the loop flag is the effect data's, fixed at creation */ }
  stop(): void { this.done = true; this.t = this.dur; }
  setPos(_x: number, _y: number, _z: number): void { /* recolours its parent; no position */ }
  setOffset(_x: number, _y: number): void { /* no position */ }
  isDone(): boolean { return this.done; }
  /** 0x82ebdc */
  update(dt: number): boolean {
    if (!this.loopData && this.dur <= this.t) { this.done = true; return true; }
    if (this.loopData && this.dur) this.t %= this.dur;
    this.frame = filterFrame(this.t, this.frames, this.dur, this.loopData) ?? 0;
    this.t += dt;
    return false;
  }
  /** the first element's colour transform of the current frame (null: identity) */
  color(): Col | null {
    const clip = this.lib.clip(this.exp);
    if (!clip || this.done) return null;
    const fr = Math.min(this.frame, clip.frameCount - 1);
    const i = clip.frameStart[fr];
    if (clip.frameStart[fr + 1] === i) return null;
    const ci = clip.elements[i * 3 + 2];
    if (ci < 0) return null;
    return [...this.lib.banks[clip.bank].c.subarray(ci * 7, ci * 7 + 7)] as Col;
  }
}

// ---------------------------------------------------------------------------------- effect instance

type CompObj = Emitter | SwfComp | Fx | FilterComp;
interface CompSlot { c: EffectComponent; started: boolean; obj: CompObj | null }

class Fx {
  readonly kind = 'nest';
  readonly ctx: Ctx;
  readonly def: EffectDef;
  readonly name: string;
  readonly opts: PlayOptions;
  readonly enemy: boolean;
  readonly scale: number;
  readonly angle: number;
  age = 0;
  loop: boolean;
  follow: boolean;
  stopped = false;
  x: number; y: number; z: number; // world units
  slots: CompSlot[];
  readonly depth: number;
  parentAngle: (() => number) | undefined;
  /** component offset +0xa8 / +0xac (0x82d204), battle px */
  ox = 0; oy = 0;

  constructor(ctx: Ctx, name: string, def: EffectDef, x: number, y: number, z: number, opts: PlayOptions, scale: number, depth: number) {
    this.ctx = ctx;
    this.name = name;
    this.def = def;
    this.opts = opts;
    this.enemy = opts.team === 1;
    this.x = x; this.y = y; this.z = z;
    this.scale = scale;
    this.angle = opts.angle ?? 0;
    this.loop = !!def.Loop;
    this.follow = !!opts.follow;
    this.parentAngle = opts.parentAngle;
    this.depth = depth;
    this.slots = def.components.map((c) => ({ c, started: false, obj: null }));
    if (opts.offset) { this.ox = opts.offset[0]; this.oy = opts.offset[1]; }
  }

  /** vt+0x48 0x82d204: the instance's offset and every live component's (vt+0x48). */
  setOffset(x: number, y: number): void {
    this.ox = x; this.oy = y;
    for (const s of this.slots) s.obj?.setOffset(x, y);
  }

  setLoop(loop: boolean): void {
    this.loop = loop;
    for (const s of this.slots) s.obj?.setLoop(loop);
  }

  /** 0x82d074 */
  stop(): void {
    for (const s of this.slots) { s.obj?.stop(); s.started = true; }
    fxSoundStop(this, this.def); // sound components (sc/sound.ts)
    this.setLoop(false);
    this.stopped = true;
  }

  setPos(x: number, y: number, z: number): void {
    this.x = x; this.y = y; this.z = z;
    for (const s of this.slots) s.obj?.setPos(x, y, z);
  }

  /** 0x82cf98 */
  isDone(): boolean {
    if (this.loop) return false;
    const forced = this.def.ForcedLength ?? 0;
    if (forced) return forced <= this.age;
    return this.slots.every((s) => s.started && (!s.obj || s.obj.isDone()));
  }

  private make(c: EffectComponent): CompObj | null {
    const ctx = this.ctx;
    const compScale = (c.scale ?? 100) * 0.01;
    if (c.type === 'SWF') {
      const lib = c.sc && c.export ? ctx.art.libs.get(c.sc) ?? (ctx.art.lib(c.sc), undefined) : undefined;
      if (!lib) return null;
      // 0x82c58c passes this instance's +0x98 / +0x9c; a nested effect's own are −1 / 0 (0x82b7ac)
      const top = this.depth === 0;
      return new SwfComp(ctx, c, lib, compScale * this.scale, top ? this.opts.swfLength ?? -1 : -1, top ? this.opts.swfFade ?? 0 : 0);
    }
    if (c.type === 'Filter') {
      // 0x82c58c type 1: only with a parent actor (effect +0x48)
      if (this.opts.filterParent === undefined || !c.sc || !c.export) return null;
      const lib = ctx.art.libs.get(c.sc) ?? (ctx.art.lib(c.sc), undefined);
      if (!lib) return null;
      const top = this.depth === 0;
      return new FilterComp(lib, c.export, c.frames ?? lib.frameCount(c.export), c.fps ?? lib.fps(c.export),
        top ? this.opts.swfLength ?? -1 : -1, !!this.def.Loop, this.opts.filterParent);
    }
    if (c.type === 'ParticleEmitter' && c.emitter) {
      const m = ctx.art.manifest.emitters;
      let e = m[c.emitter];
      if (!e) return null;
      if (this.enemy && e.EnemyVersion && m[e.EnemyVersion]) e = m[e.EnemyVersion];
      if (this.opts.skipPersistent && (e.ParticleMinLife ?? 0) >= 100000) return null;
      return new Emitter(ctx, this, e, c.layer || 'Ground', this.scale, compScale, this.angle);
    }
    if (c.type === 'Effect' && c.effect) {
      if (this.depth > 8) return null;
      const effects = ctx.art.manifest.effects;
      let name = c.effect;
      let def = effects[name];
      if (!def) return null;
      if (this.enemy && def.EnemyVersion && effects[def.EnemyVersion]) { name = def.EnemyVersion; def = effects[name]; }
      // a nested effect keeps its own Scale (0x82b7ac reads it from its data); the caller's extra
      // scale carries over
      // 0x82d484 sets the beam target on the instance's own SWF components only (type 0); a nested
      // instance starts with speed 1 (+0xb0) and no text (+0x28) of its own (0x82b7ac), and gets the
      // offset through vt+0x48 like every component (below); its parent (+0x48) is the same actor
      const nopts: PlayOptions = { ...this.opts, target: undefined, targetPivot: undefined, targetPoint: undefined,
        offset: undefined, soundPitch: undefined, text: undefined };
      const fx = new Fx(ctx, name, def, this.x, this.y, this.z, nopts,
        effectScale(def) * (this.opts.scale ?? 1), this.depth + 1);
      ctx.shake(def);
      fx.parentAngle = this.parentAngle;
      return fx;
    }
    return null;
  }

  /** 0x82bf10: true when done */
  update(dt: number): boolean {
    if (this.follow && this.opts.follow) {
      const p = this.opts.follow();
      if (p) {
        // the parent sprite's position, y + 0.01 world (−0.01 before the flip) so it sorts in front
        this.x = p[0] * W; this.y = p[1] * W + (this.ctx.art.flip ? -0.01 : 0.01); this.z = p[2] * W;
      } else {
        // 0x82d300: the parent is gone; a looping attached effect stops
        this.follow = false;
        if (this.loop) this.stop();
      }
    }
    const forced = this.def.ForcedLength ?? 0;
    if (forced && forced <= this.age && this.loop) {
      for (const s of this.slots) { s.obj = null; s.started = false; }
      this.age = 0;
    }
    // sound components start with their component (0x82bf10, sc/sound.ts); pitch = effect +0xb0
    fxSoundUpdate(this, this.def, this.age, this.stopped, this.opts.soundPitch ?? 1);
    // PivotClip / ParentLookAtOffsetRadius (0x82bf10 @0x82c2ac): every component's offset this update
    const pv = this.opts.parentView?.();
    if (pv) {
      const o = parentOffset(this.def.PivotClip as string | undefined, (this.def.ParentLookAtOffsetRadius as number | undefined) ?? 0, pv);
      if (o) this.setOffset(o[0], o[1]);
    }
    for (const s of this.slots) {
      if ((s.c.time ?? 0) > this.age) continue;
      if (!s.started) {
        s.started = true;
        if (!this.stopped) {
          s.obj = this.make(s.c);
          if (s.obj) {
            if (s.obj instanceof Fx) {
              const nf = s.obj.def.ForcedLength ?? 0;
              if (nf) s.obj.setLoop(false);
              else if (!s.obj.loop) s.obj.setLoop(this.loop);
            } else {
              s.obj.setLoop(this.loop && !forced);
            }
            s.obj.setPos(this.x, this.y, this.z);
            // 0x82c58c ends with vt+0x48(+0xa8, +0xac)
            s.obj.setOffset(this.ox, this.oy);
          }
        }
      }
      const o = s.obj;
      if (!o) continue;
      if (this.follow) o.setPos(this.x, this.y, this.z);
      if (o.update(dt)) s.obj = null;
    }
    this.age += dt;
    return this.isDone();
  }

  /**
   * 0x82a994's beam matrix for a SWF component with FlashWidth and a target (sc/beam.ts), else null. Once the
   * target actor is gone (0x82b40c clears +0x190 on its removal): a looping component hides its clip and
   * finishes (+0x181), 'hide'; any other skips the beam block, so its clip keeps the last matrix relative to
   * the component.
   */
  private beam(c: EffectComponent, o0: SwfComp, px: number, py: number, sc: number): Mat | 'hide' | null {
    const flash = (c.flashWidth as number | undefined) ?? 0;
    const o = this.opts;
    if (!flash || (!o.target && !o.targetPoint)) return null;
    let end: [number, number];
    const art = this.ctx.art;
    if (o.targetPoint) {
      end = art.gameToPx(o.targetPoint[0], o.targetPoint[1], o.targetPoint[2]);
    } else {
      const t = o.target!();
      if (!t) {
        if (o0.loop) { o0.done = true; return 'hide'; }
        const l = o0.beamLocal;
        return l ? [l[0], l[1], l[2], l[3], px + l[4], py + l[5]] : null;
      }
      end = art.gameToPx(t[0], t[1], t[2]);
      const pv = o.targetPivot?.();
      if (pv) end = [end[0] + pv[0], end[1] + pv[1]];
    }
    const m = beamMatrix([px, py], [o0.ox, o0.oy], end, flash, sc);
    o0.beamLocal = [m[0], m[1], m[2], m[3], m[4] - px, m[5] - py];
    return m;
  }

  /** this instance's running Filter components for `parent` (0x82ebdc), nested effects included */
  filters(parent: number, out: Col[]): void {
    for (const s of this.slots) {
      const o = s.obj;
      if (o instanceof Fx) o.filters(parent, out);
      else if (o instanceof FilterComp && o.parent === parent) { const c = o.color(); if (c) out.push(c); }
    }
  }

  collect(layer: string, out: DrawItem[], alphaMul: number): void {
    if (this.opts.hidden?.()) return;
    const a = alphaMul;
    for (const s of this.slots) {
      const o = s.obj;
      if (!o) continue;
      if (o instanceof Fx) { o.collect(layer, out, a); continue; }
      if (o instanceof FilterComp) continue;
      if (o instanceof SwfComp) {
        if ((s.c.layer || 'Ground') !== layer || o.done) continue;
        const art = this.ctx.art;
        const [px, py] = art.gameToPx(o.x / W, o.y / W, o.z / W);
        const gy = art.gameToPx(o.x / W, o.y / W, 0)[1];
        const sc = o.scale, lib = o.lib, exp = s.c.export!, f = o.frame;
        const col: Col = [1, 1, 1, a * o.alpha, 0, 0, 0];
        // the inner clip sits at the offset inside the component's scale (0x82a8e0 → 0x123c548)
        const bm = this.beam(s.c, o, px, py, sc);
        if (bm === 'hide') continue;
        const m = bm ?? [sc, 0, 0, sc, px + sc * o.ox, py + sc * o.oy];
        // the instance's text on its own components' TextInstanceName child (0x82c58c, +0x2c != 0)
        const tn = (s.c as { textInstanceName?: string }).textInstanceName;
        const text = this.depth === 0 && tn && this.opts.text ? { [tn]: this.opts.text } : undefined;
        const inst = o.inst;
        const dopts = inst ? (text ? { inst, text } : { inst }) : (text ? { text } : undefined);
        out.push({ layer, sortY: gy, draw: (r) => r.draw(lib, exp, inst ? inst.frame : f, m, col, dopts) });
        continue;
      }
      const em = o;
      const own = em.layer === layer;
      const shadow = layer === 'Ground' && !!em.e.Shadow && this.ctx.shadows;
      if (!own && !shadow) continue;
      for (const p of em.parts) {
        if (own) { const it = p.item(layer, a); if (it) out.push(it); }
        if (shadow) { const it = p.shadowItem(a); if (it) out.push(it); }
      }
    }
  }
}

const filterMemo = new WeakMap<EffectDef, boolean>();

/** The effect or one of its nested effects has a Filter component. */
function hasFilter(effects: Record<string, EffectDef>, def: EffectDef, depth: number): boolean {
  const m = filterMemo.get(def);
  if (m !== undefined) return m;
  let r = false;
  for (const c of def.components) {
    if (c.type === 'Filter') r = true;
    else if (c.type === 'Effect' && c.effect && effects[c.effect] && depth < 8) r = hasFilter(effects, effects[c.effect], depth + 1);
    if (r) break;
  }
  filterMemo.set(def, r);
  return r;
}

function effectScale(def: EffectDef): number {
  return def.Scale ? def.Scale * 0.01 : 1;
}

/** Layers sorted by the sort key every frame (0x856f28 → 0x856a88). */
const SORTED = new Set(['Base', 'Ground', 'Object']);

export class EffectPlayer {
  readonly art: BattleArt;
  private list: Fx[] = [];
  private nextId = 1;
  private handles = new Map<number, Fx>();
  private ctx: Ctx;
  private seqN = 0;
  private dtAcc = 0;
  /** set false to skip particle shadow copies */
  get shadows(): boolean { return this.ctx.shadows; }
  set shadows(v: boolean) { this.ctx.shadows = v; }
  /** screen shake (battle layer +0x170 time left s, +0x174 intensity, +0x178/+0x17c offset px) */
  private shakeT = 0;
  private shakeI = 0;
  private shakeRng = new Rng(0x5eed);

  constructor(art: BattleArt, seed = 12345) {
    this.art = art;
    const sh = art.manifest.arena?.shadow ?? {};
    this.ctx = {
      art, rng: new Rng(seed), seq: () => this.seqN++, shadows: true,
      shadowCol: [(sh.ShadowR ?? 0) / 255, (sh.ShadowG ?? 0) / 255, (sh.ShadowB ?? 0) / 255, 1, 0, 0, 0],
      shadowA: sh.ShadowA ?? 0,
      shake: (def) => {
        // 0x856a70: a longer shake replaces the current one, with its intensity
        const t = (def.ShakeScreen ?? 0) * 0.001;
        if (this.shakeT < t) { this.shakeT = t; this.shakeI = (def.ShakeMaxIntensity ?? 0) * 0.001; }
      },
    };
  }

  /**
   * Battle layer update 0x856f28: the offset applied to every battle-layer child this frame. While
   * time is left, amplitude A = intensity when 0 < intensity < time left, else the time left (so it
   * fades out linearly), and the offset is 6·A SC px in a random direction (the client's view RNG
   * 0x1a46dd0 draws rand(10000) · 0.0006283 rad; its seed is not reproducible); time counts down by
   * the frame dt (s).
   */
  shakeOffset(dt: number): [number, number] {
    if (!(dt > 0) || !(this.shakeT > 0)) return [0, 0];
    const t = this.shakeT, i = this.shakeI;
    const a = Math.fround(6 * (i < t && i > 0 ? i : t));
    const ang = Math.fround(this.shakeRng.int(10000) * Math.fround(0.0006283));
    const off: [number, number] = [Math.fround(Math.cos(ang) * a), Math.fround(Math.sin(ang) * a)];
    this.shakeT = t - dt;
    if (this.shakeT <= 0) { this.shakeT = 0; this.shakeI = 0; }
    return off;
  }

  get count(): number { return this.list.length; }

  /** Colour transforms the running Filter components apply to actor `parent` this frame (0x82ebdc). */
  filters(parent: number): Col[] {
    const out: Col[] = [];
    for (const e of this.list) e.filters(parent, out);
    return out;
  }

  /** The parents with running Filter components (effects played with `filterParent`), for a cheap skip. */
  filterParents(): Set<number> {
    const out = new Set<number>();
    const effects = this.art.manifest.effects;
    for (const e of this.list) if (e.opts.filterParent !== undefined && hasFilter(effects, e.def, 0)) out.add(e.opts.filterParent);
    return out;
  }

  has(name: string): boolean { return !!this.art.manifest.effects[name]; }

  /** Start an effect at logic (x, y); returns a handle for stop(). Unknown names return 0. */
  play(name: string, x: number, y: number, opts: PlayOptions = {}): number {
    const effects = this.art.manifest.effects;
    let def = effects[name];
    if (!def) return 0;
    if (opts.team === 1 && def.EnemyVersion && effects[def.EnemyVersion]) { name = def.EnemyVersion; def = effects[name]; }
    let px = x, py = y, pz = opts.z ?? 0;
    const f = opts.follow?.();
    if (f) { px = f[0]; py = f[1]; pz = f[2]; }
    const fx = new Fx(this.ctx, name, def, px * W, py * W, pz * W, opts, effectScale(def) * (opts.scale ?? 1), 0);
    this.ctx.shake(def);
    // 0x82dedc / 0x82dc54: vt+0x38 setLoop(1 / 0) right after 0x82dcb0
    if (opts.loop !== undefined) fx.setLoop(opts.loop);
    this.list.push(fx);
    const id = this.nextId++;
    this.handles.set(id, fx);
    return id;
  }

  /** Stop an effect (0x82d074): no new particles or loops; live particles and clips finish. */
  stop(handle: number): void {
    this.handles.get(handle)?.stop();
  }

  /** Delete an effect at once (manager 0x82e160: removed from the list, vt+8). */
  remove(handle: number): void {
    const e = this.handles.get(handle);
    if (!e) return;
    this.handles.delete(handle);
    const i = this.list.indexOf(e);
    if (i >= 0) this.list.splice(i, 1);
  }

  /** The effect with this handle is still running (manager 0x82e52c). */
  alive(handle: number): boolean {
    return this.handles.has(handle);
  }

  clear(): void {
    this.list = [];
    this.handles.clear();
  }

  /** Advance every effect by dtMs (split into integer-ms updates like the client's frame dt). */
  update(dtMs: number): void {
    this.dtAcc += Math.max(0, dtMs);
    const dt = Math.floor(this.dtAcc);
    if (dt <= 0) return;
    this.dtAcc -= dt;
    this.list = this.list.filter((e) => !e.update(dt));
    const live = new Set(this.list);
    for (const [h, e] of this.handles) if (!live.has(e)) this.handles.delete(h);
  }

  /** Draw the items of one layer (sorted layers by key, the others in creation order). */
  draw(r: ScRenderer, layer: string): void {
    for (const it of this.collect(layer)) it.draw(r);
  }

  /** Items of a layer with their sort keys; Base/Ground/Object come sorted, others in creation order. */
  collect(layer: string): DrawItem[] {
    const out: DrawItem[] = [];
    for (const e of this.list) e.collect(layer, out, 1);
    if (SORTED.has(layer)) {
      // stable: equal keys keep creation order
      return out.map((it, i) => ({ it, i })).sort((p, q) => p.it.sortY - q.it.sortY || p.i - q.i).map((p) => p.it);
    }
    return out;
  }
}
